import getRequest from '../utils/getRequest.js';
import {axiosTimer } from './axiosTimer.js'
import Cookies from 'js-cookie'
let token = localStorage.getItem('token') || (Cookies.get("token")?Cookies.get("token"):'');
let isContent = /^\/content/;
export const requestInter = (fetch) => {
    fetch.interceptors.request.use(function (config) {
       token =  localStorage.getItem('token') || (Cookies.get("token")?Cookies.get("token"):'');
       let refreshToken=window.localStorage.getItem("refresh_token")||''; 
       console.log(token ,'=====requestInter.js')
       if(token){ 
           config.headers["Authorization"] = 'bearer' +token ; 
           if(refreshToken){
               axiosTimer(refreshToken)
           }
       } 
        let $loadingBox = document.querySelector('.loading-box');
        $loadingBox && ($loadingBox.style.display = 'flex');
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
}

export const responseInter = (fetch) => {
    fetch.interceptors.response.use(function (response) {
        let $loadingBox = document.querySelector('.loading-box');
        $loadingBox && ($loadingBox.style.display = 'none');
        return response;
    }, function (error) {
        let $loadingBox = document.querySelector('.loading-box');
        $loadingBox && ($loadingBox.style.display = 'none');

        if (error.response && error.response.data && error.response.data.code == '101') {
            window.location.href = error.response.data.data.loginUrl;
        }

        return Promise.resolve(error.response);
        // return Promise.reject(error);
    });
}